// Service imports:
import { turnDateToSimpleTime } from '../../services/utils';
import { bugsnagNotify, fetchResponseToDetailedString } from '../../services/bugsnagUtils';
// Constant imports:
import { GET_SIGTI_API_URL } from '../../config';
// Type imports:
import { AppDispatch } from '../../index'; // Use the root dispatch type from your store
import { INewsResponse } from '../../types/api/NewsTypes';
import { REQUEST_SHARE_NEWS_FAILURE, REQUEST_SHARE_NEWS_SUCCESS, REQUEST_SHARE_NEWS_WAITING } from '../../types/redux/NewsTypes';
import { requestNewsQuery } from '../queries/newsQueries';

// ================================ REQUEST SHARE NEWS THUNK (GET NEWS) ================================
const requestShareNewsThunk = async (dispatch: AppDispatch, symbol: string, tradingDay: string, accessToken: string) => {
    // Transform date.
    const simpleDateString = turnDateToSimpleTime(new Date(tradingDay));
    // Dispatch waiting.
    dispatch(requestShareNewsWaiting(symbol, simpleDateString));

    // Start request.
    const url = GET_SIGTI_API_URL();
    const query = requestNewsQuery();

    const queryObject = {
        query,
        variables: {
            day: tradingDay,
            symbol: symbol
        }
    };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(queryObject)
        });

        if (response.ok) {
            const responseBody = await response.json();

            if (!responseBody.data) {
                dispatch(requestShareNewsFailure(symbol, simpleDateString, 'Session Expired'));
                return;
            }
            dispatch(requestShareNewsSuccess(symbol, simpleDateString, responseBody.data.news));
        } else {
            const { errorString } = await fetchResponseToDetailedString('Request System Profile', response);
            bugsnagNotify(new Error(errorString));
            dispatch(requestShareNewsFailure(symbol, simpleDateString, 'Request Failed'));
        }
    } catch (e) {
        bugsnagNotify(e as Error);
        dispatch(requestShareNewsFailure(symbol, simpleDateString, 'Network Error'));
    }
}
// ======--------- REQUEST WAITING ---------=======
const requestShareNewsWaiting = (symbol: string, tradingDay: string) => {
    return {
        type: REQUEST_SHARE_NEWS_WAITING,
        payload: {
            symbol,
            tradingDay
        }
    }
};
// ======--------- SUCCESS WAITING ---------=======
const requestShareNewsSuccess = (symbol: string, tradingDay: string, newsResponse: INewsResponse) => {
    return {
        type: REQUEST_SHARE_NEWS_SUCCESS,
        payload: {
            symbol,
            tradingDay,
            newsResponse
        }
    };
};
// ======--------- FAILURE WAITING ---------=======
const requestShareNewsFailure = (symbol: string, tradingDay: string, error: string) => {
    return {
        type: REQUEST_SHARE_NEWS_FAILURE,
        payload: {
            symbol,
            tradingDay,
            error
        }
    };
};
// ======--------- GET NEWS CONTROLER ---------=======
export const requestShareNews =
    (symbol: string, tradingDay: string, accessToken: string) =>
    (dispatch: AppDispatch) =>
    requestShareNewsThunk(dispatch, symbol, tradingDay, accessToken);